import React from "react";

const Blog3 = () => {
  return (
    <div>
      <div>
        <div className="blog">
          <div className="row">
            <div className="col-md-9 article-area">
              <h2
                style={{ marginTop: "85px" }}
                className="mb-5 text-center project-title "
              >
                CRUD operations in MongoDB with Node JS
              </h2>
              <div style={{ justifyContent: "center" }} className="d-flex">
                <img
                  className="img-fluid"
                  src="https://i.ibb.co/82KG2bk/download.png"
                  alt="css-flexbox"
                />
              </div>
              <br />
              <article>
                <p>
                  CRUD operations are the basic methods of interacting with
                  MongoDB database via server. CRUD stands for
                </p>
                <ol>
                  <li>
                    <b>C</b>reat{" "}
                  </li>
                  <li>
                    <b>R</b>ead
                  </li>
                  <li>
                    <b>U</b>pdate
                  </li>
                  <li>
                    <b>D</b>elete
                  </li>
                </ol>
                <br />
                <p>
                  This method is the basic and primary method to manage the data
                  form a database with server. If we want to make a web
                  application dynamic. Then we need to put data everytime and
                  need to change sometimes. For that part we use CRUD operation
                  to handle all this work.
                </p>
                <br />
                <br />
                <p>
                  <b>MongoDB CRUD operations:</b>
                </p>
                <p>
                  The crud operations varies in different database. It is not
                  same for every database. It actually depends on how the
                  database methods called. In MongoDB we use
                </p>
                <ol>
                  <li>Post to create a data.</li>
                  <li>Get to read the data.</li>
                  <li>Put to update the data and</li>
                  <li>Delete to delete the data.</li>
                </ol>
                <br />
                <p>
                  It can be other in others database. But the functionality
                  generally remains same for every database.
                </p>
                <br />
                <br />
                <p>
                  The CRUD operation is generally handled by the server. The
                  database keeps the data and contains some method or
                  functionality. But all options are generally handled by the
                  backend server. In this blog, we will discuss how the
                  operations are handled by the Node JS server.
                </p>
                <br />
                <br />
                <p>
                  <b>Node JS MongoDB CRUD operation:</b>
                </p>
                <p>
                  Node JS is a JavaScript runtime. The server uses javascript to
                  execute all the operations. It is very popular in the web
                  application community. Because the website uses Javascript
                  also. So it became very easy to handle.
                </p>
                <br />
                <p>
                  On the other hand, MongoDB is a NoSQL database. For that, the
                  database is very easy to handle and the combination of
                  brjavascript and Node JS is very popular.
                </p>
                <br />
                <p>
                  For doing any operation in MongoDB first we need to require my
                  database to the server. Then we need to add some key of my
                  database and we are ready to make some operation in the
                  server.
                </p>
                <br />
                <p>
                  Then we need to add a get request to the server to see if the
                  server is connected or not. If it is connected we are ready to
                  add CRUD operation request. Almost all the request is
                  connected with the frontend so we need to make a frontend
                  first. The frontend request the server for a operation and the
                  server act accordingly and it make a request to the database
                  for its ows crud operation methods. If it is MongoDB then is
                  makes its operations and that is get, post, put and delete.
                </p>
                <br />
                <p>
                  So, in that way a full crud operations occurs in a web
                  application. A server is not only use for this 4 aopration it
                  also can query data and can do aggregation. There is a lot of
                  things more than CRUD operation. But the basic operation of a
                  database is CRUD. By this we can handel most of our work and
                  it is vastly used method.
                </p>
              </article>
            </div>
            {/*--------------- Adds section -------------- */}
            <div className="col-md-3">
              <img
                style={{ marginTop: "70px" }}
                src="https://i.ibb.co/HXcfLN6/9656093656252652900.gif"
                alt=""
                className="img-fluid"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Blog3;
